__turbopack_context__.v({
  "className": "geist_mono_fa933ac5-module__c-shoG__className",
  "variable": "geist_mono_fa933ac5-module__c-shoG__variable",
});
